















































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';
import { DiscreetProgressValue } from './types';

const cssPrefix = 'sw-discreet-progress';

@Component({
  components: {},
})
export default class SwDiscreetProgress extends SwExtendedVue {
  @Prop({ type: Number, required: true })
  value: number;

  @Prop({ type: Array, default(): DiscreetProgressValue[] {
    return [
      { value: 5, color: utilService.colorConst.statusNormal },
      { value: 4, color: utilService.colorConst.statusLow },
      { value: 3, color: utilService.colorConst.statusMinor },
      { value: 2, color: utilService.colorConst.statusMajor },
      { value: 1, color: utilService.colorConst.statusHigh },
    ];
  } })
  discreetValues: DiscreetProgressValue[];

  cssPrefix = cssPrefix;

  get discreetBacgroundColor() {
    const discreetValue = this.discreetValues.find(x => x.value === this.value);
    if (discreetValue) {
      return discreetValue.color;
    }
    return 'black';
  }

  get baseStyle(): CSSStyleOptions {
    return {
      backgroundColor: this.discreetBacgroundColor,
    };
  }
}
